import { createSlice } from "@reduxjs/toolkit";
import { AUTH_SLICE_NAME } from "./actions";
import {
  loginUserReducer,
  logoutReducer,
  registerReducer,
  resetPasswordReducer,
  updatePasswordReducer,
} from "./reducers";

export interface AuthState {
  isLoading: boolean;
}

const initialState: AuthState = {
  isLoading: false,
};

export const { reducer: auth } = createSlice({
  name: AUTH_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    loginUserReducer(builder);
    registerReducer(builder);
    resetPasswordReducer(builder);
    updatePasswordReducer(builder);
    logoutReducer(builder);
  },
});
